import React, { useState, useEffect } from 'react';
import MediaQuery from 'react-responsive';
import PageForm from "components/pageForm/PageForm";
import SubNavbar from "components/SubNavbar/SubNavbar";
import ProfileDocuments from "components/Dashboard/profileDocuments";
import DatePicker from "react-datepicker";
import Button from "components/button";
import { Filter } from "assets/icons";
import BottomSheet from "components/bottomSheet/BottomSheet";

const Dashboard = () => {
    //first date of the month and last date of the month
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    
    // États pour le BottomSheet de filtre mobile
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [tempDateRange, setTempDateRange] = useState([null, null]);
    const [tempStartDate, tempEndDate] = tempDateRange;

    useEffect(() => {
        const currentMonth = new Date();
        const startDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
        const endDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0);
        // Set the date range in the state
        setDateRange([startDate, endDate]);
    }, []);

    const clearFilters = () => {
        setDateRange([null, null]);
    };
    
    // Ouvrir le BottomSheet et initialiser les valeurs temporaires
    const openFilterSheet = () => {
        setTempDateRange(dateRange);
        setIsFilterOpen(true);
    };
    
    // Appliquer les filtres
    const applyFilters = () => {
        setDateRange(tempDateRange);
        setIsFilterOpen(false);
    };

    return (
        <>
            <PageForm>
                <>
                    <SubNavbar>
                        <div className="flex items-center gap-3 justify-start w-full">
                            {/* Desktop: DatePicker + Clear button */}
                            <MediaQuery minWidth={768}>
                                <div className="w-auto">
                                    <DatePicker
                                        selectsRange={true}
                                        startDate={startDate}
                                        endDate={endDate}
                                        onChange={(update) => {
                                            setDateRange(update);
                                        }}
                                        className='min-w-[250px] h-10 pl-3 pr-3 ft-b border rounded-md text-sm focus:border-yellow-500 focus:outline-none'
                                        locale='fr-FR'
                                        dateFormat="dd/MM/yyyy"
                                        placeholderText="Sélectionner une période"
                                    />
                                </div>
                                <Button
                                    color="SECONDARY"
                                    size="SM"
                                    onClick={clearFilters}
                                    className="whitespace-nowrap"
                                >
                                    Effacer les filtres
                                </Button>
                            </MediaQuery>
                            
                            {/* Mobile: Filter button */}
                            <MediaQuery maxWidth={767}>
                                <Button
                                    color={'SECONDARY'}
                                    size={'SM'}
                                    onClick={openFilterSheet}
                                >
                                    <Filter wh={16} color="#374151" />
                                    <span>Filtrer</span>
                                </Button>
                            </MediaQuery>
                        </div>
                    </SubNavbar>
                    {/* Documents */}
                    <ProfileDocuments dateRange={dateRange} setDateRange={setDateRange} />
                    
                    {/* Bottom Sheet Filtre pour mobile */}
                    <BottomSheet
                        isOpen={isFilterOpen}
                        onClose={() => setIsFilterOpen(false)}
                        title="Filtrer"
                    >
                        <div className="flex flex-col gap-4">
                            {/* Période */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">
                                    Période
                                </label>
                                <DatePicker
                                    selectsRange={true}
                                    startDate={tempStartDate}
                                    endDate={tempEndDate}
                                    onChange={(update) => {
                                        setTempDateRange(update);
                                    }}
                                    isClearable={true}
                                    className='w-full h-10 pl-3 pr-8 ft-b border rounded-lg text-sm focus:border-yellow-500 focus:outline-none'
                                    locale='fr-FR'
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="Sélectionner une période"
                                />
                            </div>

                            {/* Bouton Appliquer */}
                            <Button
                                color="PRIMARY"
                                size="FULL"
                                onClick={applyFilters}
                                className="w-full mt-2"
                            >
                                Appliquer
                            </Button>
                        </div>
                    </BottomSheet>
                </>
            </PageForm>
        </>
    );
};

export default Dashboard;
